import type { ListingDocumentType } from '@bb/domain/dist/types';

/**
 *  The options are sorted in the alphabetical order by label
 *  except for Listing Paperwork and Other
 * */
export const DOCUMENT_TYPE_OPTIONS: {
  label: string;
  value: ListingDocumentType;
}[] = [
  {
    label: 'Listing Paperwork',
    value: 'listingAgreement',
  },
  {
    label: 'Buyer Representation Agreement',
    value: 'buyerAgreement',
  },
  {
    label: 'Confirmation of Cooperation',
    value: 'confirmationCooperation',
  },
  {
    label: 'MLS Data Sheet',
    value: 'dataSheet',
  },
  {
    label: 'Offer Summary Doc',
    value: 'form801',
  },
  {
    label: 'Purchase Agreement',
    value: 'purchaseAgreement',
  },
  {
    label: 'Schedule / Disclosure',
    value: 'schedule',
  },
  {
    label: 'Working with a Realtor',
    value: 'withRealtor',
  },
  {
    label: 'Other',
    value: 'other',
  },
];

const DOCUMENT_TYPE_MAP = DOCUMENT_TYPE_OPTIONS.reduce<
  Partial<Record<ListingDocumentType, string>>
>((acc, option) => {
  acc[option.value] = option.label;
  return acc;
}, {});

const formatDocumentType = (documentType: ListingDocumentType) =>
  DOCUMENT_TYPE_MAP[documentType] ?? '';

export default formatDocumentType;
